/**
 * @module platformSelector
 */

/**
 * Platform Selector: Build and Show
 *
 * @param {Cookie} Cookies - Object from Cookies-module
 */

module.exports = function( Cookies ) {
    const sprintf = require( '../../../_common/js/utilities/sprintf' ),
        inputSearch = document.querySelector( '.input-search input[name=search]' );

    let PLATFORMS = null;

    inputSearch.addEventListener( 'keyup', function( e ) {
        const searchValue = e.target.value.toLowerCase(),
            platformsFound = Array.from( this.closest( '.platform-list' ).querySelectorAll( '.platform-el' ) ),
            message = document.querySelector( 'span.not-found' );
        let platformSearchHasItem = platformsFound.length;

        platformsFound.map( ( item ) => {
            if ( item.dataset.pFilter.includes( searchValue ) ) {
                item.classList.remove( 'd-none' );
            } else {
                item.classList.add( 'd-none' );
                platformSearchHasItem = platformSearchHasItem - 1;
            }
        } );

        platformSearchHasItem === 0 && inputSearch
            ? message.classList.remove( 'd-none' )
            : message.classList.add( 'd-none' );
    } );

    const Events = {
        onModalShow( e ) {
            const button = e.relatedTarget, // Button that triggered the modal
                input = button.querySelector( 'input' ),
                modal = this,
                search = modal.querySelector( 'input[name=search]' ),
                selectedName = input.getAttribute( 'name' ),
                selectedSlug = input.value,
                selectedStatus = input.getAttribute( 'data-statuses' );
            let linkEl = 'div';
            if ( button.getAttribute( 'data-bs-whatever' ) !== undefined ) {
                modal.setAttribute('data-selector-id', button.getAttribute('data-bs-whatever'))
            }

            if ( button.getAttribute( 'data-direct-link' ) ) {
                linkEl = 'a';
            }

            button.classList.remove( 'where-changed' );
            modal.dataset.inputName = selectedName;
            search.value = '';

            setTimeout( function() {
                search.focus();
            }, 550 );

            if ( null === PLATFORMS ) {
                fetch( '/wp-admin/admin-ajax.php?action=platforms_list', { method: 'GET' } )
                    .then( ( response ) => response.json() )
                    .then( ( response ) => {
                        PLATFORMS = response;
                        Logic.buildModal( modal, selectedSlug, selectedStatus, linkEl );
                    } );
            } else {
                Logic.buildModal( modal, selectedSlug, selectedStatus, linkEl );
            }
        },
        onModalHide() {
            this.dataset.inputName = '';
            document.querySelector( '.modal-body span.not-found' ).classList.add( 'd-none' );
        },
        onPlatformClick() {
            const platform = this,
                modal = this.closest( '.modal' ),
                input = modal.dataset.inputName,
                selectedSlug = platform.dataset.pSlug || '',
                selectedApp = platform.dataset.pApp || '',
                selectedTitle = platform.innerText || '',
                langCode = document.querySelector( 'html' ).getAttribute( 'lang' ).substr( 0, 2 );
            let inputByName = document.querySelector( `input[name="${ input }"]` );
            if ( modal.dataset.selectorId !== "null" ) {
                inputByName = document.querySelector( `[data-bs-whatever='${ modal.dataset.selectorId }'] input` );
            }
            const themeSelector = inputByName.closest( '.theme--selector' ),
                themeSelectorName = themeSelector.querySelector( '.name' );
            const moreDetails = themeSelectorName.closest( 'form' ).querySelectorAll( '.more-details' );

            inputByName.value = selectedSlug;
            inputByName.dataset.selectedSlug = selectedSlug;
            inputByName.dataset.selectedApp = selectedApp;
            themeSelector.classList.add( 'where-changed' );
            themeSelectorName.innerHTML = selectedTitle;
            moreDetails.forEach( ( item ) => {
                const pair = item.dataset.patternPair,
                    source = item.closest( 'form' ).querySelector( 'input[name=source]' ).value,
                    target = item.closest( 'form' ).querySelector( 'input[name=target]' ).value,
                    href = ( langCode === 'en' ? '' : '/' + langCode ) + sprintf( pair, source, target );
                item.setAttribute( 'href', href );
            } );

            Logic.savePlatformByType( input, selectedApp );

            const modalForJq = new bootstrap.Modal( modal, {} );
            modalForJq._hideModal();
            document.querySelector( '.modal-backdrop.show' ).remove();

            if ( modal.dataset.selectorId !== "null" ) {
                const oneDirectionSourceEl = themeSelector.closest( '[data-one-direction]' ).querySelector( '[data-one-direction-platform="source"]' ).querySelector( 'input[name="source"]' );
                const oneDirectionTargetEl = themeSelector.closest( '[data-one-direction]' ).querySelector( '[data-one-direction-platform="target"]' ).querySelector( 'input[name="target"]' );
                const getSourceTitle = function() {
                    const sourceEl = oneDirectionSourceEl.closest( '[data-bs-whatever]' );
                    if ( sourceEl && sourceEl.querySelector( '.name' ) ) {
                        return sourceEl.querySelector( '.name' ).innerHTML;
                    } else {
                        const sourceSelector = themeSelector.closest( '[data-one-direction]' ).querySelector( '[data-one-direction-platform="source"]' );
                        return sourceSelector ? sourceSelector.querySelector( 'span' ).innerHTML : '';
                    }
                };
                const getTargetTitle = function() {
                    const targetEl = oneDirectionTargetEl.closest( '[data-bs-whatever]' );
                    if ( targetEl && targetEl.querySelector( '.name' ) ) {
                        return targetEl.querySelector( '.name' ).innerHTML;
                    } else {
                        const targetSelector = themeSelector.closest( '[data-one-direction]' ).querySelector( '[data-one-direction-platform="target"]' );
                        return targetSelector ? targetSelector.querySelector( 'span' ).innerHTML : '';
                    }
                };

                jQuery.ajax({
                    url: window.location.origin + '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: {
                        action: 'theme_entities_pair_shortcode',
                        'source': oneDirectionSourceEl.dataset.selectedSlug,
                        'target': oneDirectionTargetEl.dataset.selectedSlug,
                        'sourceTitle': getSourceTitle(),
                        'targetTitle': getTargetTitle(),
                    },
                    success: function(data) {
                        themeSelector.closest( '[data-one-direction]' ).querySelector( '.ajax-entities-title-source' ).innerHTML = getSourceTitle();
                        themeSelector.closest( '[data-one-direction]' ).querySelector( '.ajax-entities-title-target' ).innerHTML = getTargetTitle();
                        themeSelector.closest( '[data-one-direction]' ).querySelector( '.ajax-entities-block' ).innerHTML = data;
                    },
                    error: function() {
                        themeSelector.closest( '[data-one-direction]' ).querySelector( '.ajax-entities-block' ).innerHTML = "<div class='h2 text-warning text-center'>Can`t receive data from server. Reload page and try again.</div>";
                    }
                })

                if(oneDirectionSourceEl && oneDirectionTargetEl) {
                    Logic.savePlatformByType( 'source', oneDirectionSourceEl.dataset.selectedApp );
                    Logic.savePlatformByType( 'target', oneDirectionTargetEl.dataset.selectedApp );
                }
            }

        },
    };

    Logic = {
        buildModal( modal, selectedSlug, selectedStatus, linkEl ) {
            const title = 't',
                app = 'c',
                slug = 's',
                status = 'a',
                landings = 'p',
                message = document.querySelector( '.modal-body span.not-found' ),

                statuses = selectedStatus.split( ',' ).map( function( value ) {
                    return value.trim().toString();
                } ).filter( function( value ) {
                    return value;
                } );

            const landingName = ( selectedStatus === 'pair' ) ? selectedStatus : '';
            const langCode = document.querySelector( 'html' ).getAttribute( 'lang' ).slice( 0, 2 );

            modal.querySelector( '.modal-body' ).innerHTML = '';

            for ( const platform in PLATFORMS.data ) {
                if ( PLATFORMS.data.hasOwnProperty( platform ) && ( statuses.indexOf( PLATFORMS.data[ platform ][ status ] ) !== -1 || ( landings && PLATFORMS.data[ platform ][ landings ].includes( landingName ) ) ) ) {
                    const item = document.createElement( linkEl ),
                        itemSlug = document.createElement( 'div' ),
                        isActive = ( selectedSlug === PLATFORMS.data[ platform ][ slug ] );

                    item.href = ( langCode === 'en' ? '' : '/' + langCode ) + '/' + PLATFORMS.data[ platform ][ slug ] + '/';
                    item.classList.add( 'platform-el' );
                    isActive ? item.classList.add( 'active' ) : null;
                    item.dataset.pSel = 0;
                    item.dataset.pSlug = PLATFORMS.data[ platform ][ slug ];
                    item.dataset.pApp = PLATFORMS.data[ platform ][ app ];
                    item.dataset.pFilter = PLATFORMS.data[ platform ][ title ].toLowerCase();
                    item.innerHTML = PLATFORMS.data[ platform ][ title ];

                    itemSlug.classList.add( 'pl', `pl__${ PLATFORMS.data[ platform ][ slug ] }` );

                    item.prepend( itemSlug );
                    modal.querySelector( '.modal-body' ).append( item );
                    item.addEventListener( 'click', Events.onPlatformClick );
                }
            }

            modal.querySelector( '.modal-body' ).append( message );
        },
        formLoaded() {
            let name, value,
                results = {},
                platforms = document.querySelectorAll( 'input[rel=platforms]' );

            for ( let i = 0; i < platforms.length; i++ ) {
                if ( platforms.hasOwnProperty( i ) ) {
                    value = platforms[ i ].dataset.selectedApp || '';
                    name = platforms[ i ].getAttribute( 'name' ) || '';
                    if ( value && name ) {
                        results[ name ] = value;
                    }
                }
            }

            for ( const j in results ) {
                if ( results.hasOwnProperty( j ) ) {
                    Logic.savePlatformByType( j, results[ j ] );
                }
            }

            if ( document.querySelector( 'label[data-bs-whatever="one-direction-import-selector-source"] input[rel=platforms]' ) ) {
                Logic.savePlatformByType( 'source', document.querySelector( 'label[data-bs-whatever="one-direction-import-selector-source"] input[rel=platforms]' ).dataset.selectedApp );
            }

            if ( document.querySelector( 'label[data-bs-whatever="one-direction-import-selector-target"] input[rel=platforms]' ) ) {
                Logic.savePlatformByType( 'target', document.querySelector( 'label[data-bs-whatever="one-direction-import-selector-target"] input[rel=platforms]' ).dataset.selectedApp );
            }

        },
        getPlatformByType( type ) {
            return Cookies.get( type );
        },
        savePlatformByType( type, value ) {
            Cookies.create( type, value, '100y', '/' );
        },

    };

    Logic.formLoaded();

    const selectorModalDialog = document.getElementById( 'selectorModalDialog' );
    selectorModalDialog.addEventListener( 'show.bs.modal', Events.onModalShow );
    selectorModalDialog.addEventListener( 'hide.bs.modal', Events.onModalHide );

    return {
        get( type ) {
            Logic.getPlatformByType( type );
        },
        set( type, value ) {
            Logic.savePlatformByType( type, value );
        },
    };
};
